<template>
  <div id="fonts-page" class="page-wrapper">
    <h1>Fonts</h1>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
#fonts-page {
}
</style>
